interface SortableTransition {
  duration: number;
  easing: string;
}

const DEFAULT_TRANSITION: SortableTransition = {
  duration: 300,
  easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
};

const isReducedMotion = (): boolean =>
  typeof globalThis.matchMedia === 'function' && globalThis.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const getSortableTransition = (): SortableTransition | null => (isReducedMotion() ? null : DEFAULT_TRANSITION);
